import { useState, useEffect } from "react";
import { useFirebase } from '../firebase/FirebaseContext';
// use navigate
import { useNavigate } from "react-router-dom";

import { useAuth } from '../firebase/AuthContext';
import { collection, getDocs, getDoc, doc } from 'firebase/firestore';

export default function Subscription() {
    const { user } = useAuth();
    const { db } = useFirebase();
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [creditsLeft, setCreditsLeft] = useState("");

    useEffect(() => {
        if (user?.orgId) {
            console.log(user.orgId);
            loadPlaygroundSessions();
            printOrgDocument();
        }
    }, [user]);


    const getCheckoutSession = async () => {
        const result = await fetch("https://backend.canopylabs.ai/create-checkout-session", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ org_id: user?.orgId })
            // optionally: mode: "cors" if your server permits it
          })

        const result_dict = await result.json()
        console.log(result_dict);
        if (result_dict.url) {
            window.location.href = result_dict.url;
        } else {
            console.error("Error creating checkout session:", result_dict);
        }


    };
    //write function to print user document to console

    //write function to print organisations/{user.orgId} document to console
    const printOrgDocument = async () => {
        if (!user?.orgId || !db) return;
        try {
            const orgRef = doc(db, `organisations/${user.orgId}`);
            const orgSnapshot = await getDoc(orgRef);
            if (orgSnapshot.exists()) {

                const creditsLeftCalc = Math.floor((orgSnapshot.data().credits - orgSnapshot.data().creditsUsed)/3600).toString();
                setCreditsLeft(creditsLeftCalc);
                console.log('Organisation Document:', orgSnapshot.data());
            } else {
                console.log('No such organisation document!');
            }

        }
        catch (error) {
            console.error('Error fetching organisation document:', error);
        }
    }



    const loadPlaygroundSessions = async () => {
        if (!user?.orgId || !db) return;
        
        setLoading(true);
        try {
            const sessionsRef = collection(db, `organisations/${user.orgId}/playgroundSessions`);
            const snapshot = await getDocs(sessionsRef);
            
            const sessions = [];
            snapshot.forEach((doc) => {
                const docData = doc.data();
                // Filter for docs that have all required fields
                if (docData.createdAt && docData.deactivatedAt && docData.totalTimeActiveSeconds) {
                    sessions.push({
                        id: doc.id,
                        startTime: docData.createdAt.toDate(), // Convert Firebase timestamp to Date
                        endTime: docData.deactivatedAt.toDate(), // Convert Firebase timestamp to Date
                        totalTimeActiveSeconds: docData.totalTimeActiveSeconds
                    });
                }
            });
            
            // Sort by start time in reverse order (newest first)
            sessions.sort((a, b) => b.startTime - a.startTime);
            
            setData(sessions);
        } catch (error) {
            console.error('Error loading playground sessions:', error);
        } finally {
            setLoading(false);
        }
    };

    const formatDateTime = (date) => {
        const now = new Date();
        const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        const dateOnly = new Date(date.getFullYear(), date.getMonth(), date.getDate());
        const diffDays = Math.floor((today - dateOnly) / (1000 * 60 * 60 * 24));
        
        const timeStr = date.toLocaleTimeString('en-US', { 
            hour: 'numeric', 
            minute: '2-digit',
            hour12: true 
        });
        
        let dateStr;
        if (diffDays === 0) {
            dateStr = "Today";
        } else if (diffDays === 2) {
            dateStr = "2 days ago";
        } else if (diffDays === 7) {
            dateStr = "Last week";
        } else {
            dateStr = date.toLocaleDateString('en-US', { 
                month: 'short', 
                day: 'numeric' 
            });
        }
        
        return `${timeStr}, ${dateStr}`;
    };

    const calculateDuration = (start, end) => {
        const diffMs = end - start;
        const diffMinutes = Math.floor(diffMs / (1000 * 60));
        return `${diffMinutes} min`;
    };

    if (loading) {
        return (
            <div className="m-4">
                <div className="flex items-center justify-center p-8">
                    <div className="text-gray-500">Loading sessions...</div>
                </div>
            </div>
        );
    }

    return (
        <div className="m-4">
            <div className="mb-8 p-6 bg-gray-50 rounded-lg border border-gray-100">
                <div className="flex items-center justify-between">
                    <div className="flex items-center space-x-8">
                        <div>
                            <div className="text-xs uppercase tracking-wide text-gray-400 mb-1">Credits</div>
                            <div className="text-2xl font-light text-gray-900">{creditsLeft}</div>
                        </div>
                    </div>
                    <div className="flex space-x-2">
                        <button 
                            className="px-5 py-2 bg-black text-white text-sm font-medium rounded-md hover:bg-gray-800 transition-colors"
                            onClick={getCheckoutSession}>
                            Upgrade
                        </button>
                    </div>
                </div>
            </div>

            <table className="w-full text-sm">
                <thead>
                    <tr className="border-b border-gray-200">
                        <th className="px-4 py-2 text-left font-light text-gray-500">Start Time</th>
                        <th className="px-4 py-2 text-left font-light text-gray-500">End Time</th>
                        <th className="px-4 py-2 text-left font-light text-gray-500">Duration</th>
                    </tr>
                </thead>
                <tbody>
                    {data.length === 0 ? (
                        <tr>
                            <td colSpan="3" className="px-4 py-8 text-center text-gray-500">
                                No playground sessions found
                            </td>
                        </tr>
                    ) : (
                        data.map((row, index) => (
                            <tr key={row.id || index} className="border-b border-gray-100">
                                <td className="px-4 py-2">{formatDateTime(row.startTime)}</td>
                                <td className="px-4 py-2">{formatDateTime(row.endTime)}</td>
                                <td className="px-4 py-2">{calculateDuration(row.startTime, row.endTime)}</td>
                            </tr>
                        ))
                    )}
                </tbody>
            </table>
        </div>
    );
}